/* eslint-disable */
import {createWebHashHistory, createRouter} from "vue-router";
import Login from "@/components/Login.vue";
import Login2 from "@/components/Login2.vue";
import Dashboard from "@/components/dashboard/Dashboard.vue";
import Dashboard2 from "@/components/Dashboard2.vue";
import NewBill from "@/components/NewBill.vue";
import Bill from "../../public/PrintDocs/Bill/Bill.vue";
import DemandNotice from "../../public/PrintDocs/notice/DemandNotice.vue";
import ConstructionPermits from "../../public/PrintDocs/ConstructionPermits/ConstructionPermits.vue";
import PrintReceipt from "../../public/PrintDocs/Receipts/PrintReceipt.vue";
import BillsRaised from "@/components/invoices/BillsRaised.vue";
import BillsReceipted from "@/components/invoices/BillsReceipted.vue";
import UnPaidBills from "@/components/invoices/UnPaidBills.vue";
import ReceiptedPayments from "@/components/payments/ReceiptedPayments.vue";
import BulkReceipts from "@/components/payments/BulkReceipts.vue";
import ReceiptsNew from "@/components/payments/ReceiptsNew.vue";
import TradePermts from "@/components/TradePermts";
import TradePermit from "../../public/PrintDocs/Trade-Permit/TradePermit";
import TradePermitWithNoLogo from "../../public/PrintDocs/Trade-Permit/TradePermitWithNoLogo";
import Customers from "@/components/Customers";
import AddUser from "@/components/systemusers/AddUser";
import Users from "@/components/systemusers/Users";
import Transactions from "@/components/Transactions";
import Zones from "@/components/systemusers/Zones";
import FinanceAct from "@/components/finance-act/FinanceAct";
import Department from "@/components/systemsettings/Department";
import RevenueStream from "@/components/systemsettings/RevenueStream";
import SubCountyReport from "../../public/PrintDocs/Print-Reports/SubCountyReport";
import SBPBulkInvoiceReport from "../../public/PrintDocs/Print-Reports/SBPBulkInvoiceReport";
import Rentals from "@/components/rent/Rentals";
import Stalls from "@/components/rent/Stalls";
import AgentsTransactions from "@/components/Transactions/AgentsTransactions";
import UserLogs from "@/components/systemusers/UserLogs";
import AllUserLogs from "@/components/systemusers/AllUserLogs";
import UserCollections from "@/components/systemusers/UserCollections";
import ReportsSubCounty from "@/components/reports/collectionbysubcounties/ReportsSubCounty";
import ReportsSubCountyDetails from "@/components/reports/collectionbysubcounties/AllTransactions";
import ReportsSubCountyStreams from "@/components/reports/collectionbysubcounties/ReportsSubCountyStreams";
import ReportsSubCountyStreamsBreakdown from "@/components/reports/collectionbysubcounties/ReportsSubCountyStreamsBreakdown";
import ReportsSubCountyStreamsDetails from "@/components/reports/collectionbysubcounties/ReportsSubCountyStreamsDetails";
import LiveMonitoring from "@/components/livemonitoring/LiveMonitoring";
import ReportsSubCountyZones from "@/components/reports/collectionbysubcounties/ReportsSubCountyZones";
import ReportsSubCountyZonesDetails from "@/components/reports/collectionbysubcounties/ReportsSubCountyZonesDetails";
import ReportsSubCountyAgents from "@/components/reports/collectionbysubcounties/ReportsSubCountyAgents";
import ReportsSubCountyAgentDetails from "@/components/reports/collectionbysubcounties/ReportsSubCountyAgentDetails";
import Mapping from "@/components/Mapping";
import CertBizStats from "@/components/sbp/CertBizStats";
import PendingValidation from "@/components/sbp/PendingValidation";
import ReportsAgents from "@/components/reports/agents/ReportsAgents";
import ReportsAgentsDetails from "@/components/reports/agents/ReportsAgentsDetails";

import PendingInspection from "@/components/sbp/PendingInspection";
import PendingApproval from "@/components/sbp/PendingApproval";
import Declined from "@/components/sbp/Declined";
import Approved from "@/components/sbp/Approved";
import Expired from "@/components/sbp/Expired";
import PaidSBP from "@/components/sbp/PaidSBP";
import UnPaidSBP from "@/components/sbp/UnPaidSBP";
import SbpUnPaidBills from "@/components/sbp/SbpUnPaidBills";
import SbpPaidBills from "@/components/sbp/SbpPaidBills";
import SBPMap from "@/components/sbp/SBPMap";
import SBPFilterMap from "@/components/sbp/SBPFilterMap.vue";
import TargetsSubCounty from "@/components/systemsettings/TargetsSubCounty";
import TargetsCollectors from "@/components/systemsettings/TargetsCollectors";
import TargetStream from "@/components/systemsettings/TargetStream";
import TargetsZones from "@/components/systemsettings/TargetsZones.vue";
import TargetsWards from "@/components/systemsettings/TargetsWard.vue";
import ReportsSubCountyTeam from "@/components/reports/collectionbysubcounties/ReportsSubCountyTeam";
import ReportsSubCountyTeamDetails from "@/components/reports/collectionbysubcounties/ReportsSubCountyTeamDetails";
import BusinessData from "@/components/sbp/data/BusinessData";
import BusinessMapping from "@/components/sbp/data/BusinessMapping";
import ParkingFleet from "@/components/parking/ParkingFleet";
import ParkingFleetNewSacco from "@/components/parking/ParkingFleetNewSacco";
import ParkingFleetPayment from "@/components/parking/ParkingFleetPayment";
import ParkingSticker from "../../public/PrintDocs/Parking-Sticker/ParkingSticker";

import ReportsStreams from "@/components/reports/streams/ReportsStreams";
import ReportsStreamsSubcounties from "@/components/reports/streams/ReportsStreamsSubcounties.vue"
import ReportsStreamsWards from "@/components/reports/streams/ReportsStreamsWards"
import ReportsStreamsZones from "@/components/reports/streams/ReportsStreamsZones"

import SetAccounts from "@/components/systemusers/SetAccounts";
import ReportsSubCountyRevenueStreams from "@/components/reports/collectionbysubcounties/ReportsSubCountyRevenueStreams";
import ParkingFleetDetails from "@/components/parking/ParkingFleetDetails";
import DailyParking from "@/components/parking/DailyParking";
import MonthlyParking from "@/components/parking/MonthlyParking";
import WeeklyParking from "@/components/parking/WeeklyParking";
import BusParkParking from "@/components/parking/BusParkParking";
import VehicleRegister from "@/components/parking/VehicleRegister";
import ClampedVehicles from "@/components/parking/ClampedVehicles";
import ParkingDashboard from "@/components/parking/ParkingDashboard";
import ParkingFleetDetailsStatements from "@/components/parking/ParkingFleetDetailsStatements";
import ParkingFleetDetailsHistory from "@/components/parking/ParkingFleetDetailsHistory";
import ActiveUsers from "@/components/livemonitoring/ActiveUsers";
import InActiveUsers from "@/components/livemonitoring/InActiveUsers";
import DormantUsers from "@/components/livemonitoring/DormantUsers";
import NeverLoggedIn from "@/components/livemonitoring/NeverLoggedIn";
import Recon from "@/components/recon/Recon";
import ReconRealtime from "@/components/recon/ReconRealtime.vue";
import ReconDetails from "@/components/recon/ReconDetails.vue";
import AllReconDetails from "@/components/recon/AllReconDetails.vue";
import FlaggedTransactionCorrection from "@/components/actioncenter/FlaggedTransactionCorrection";
import TransactionCorrectionRequest from "@/components/actioncenter/TransactionCorrectionRequest";
import otp from "@/components/otp.vue";
import otp2 from "@/components/otp2.vue";

import FireDashboard from "@/components/fire/FireDashboard.vue";
import CertFirePending from "@/components/fire/CertFirePending.vue";
import PendingApprovalFire from "@/components/fire/PendingApprovalFire.vue";
import ActiveFireCert from "@/components/fire/ActiveFireCert.vue";
import FirePermit from "../../public/PrintDocs/FireCertificate/FirePermit.vue";

import LandRate from "@/components/landrate/LandRate.vue";
import PendingTransfers from "@/components/landrate/PendingTransfers";
import DeclinedTransfers from "@/components/landrate/DeclinedTransfers";
import ReApproveTransfers from "@/components/landrate/ReApproveTransfers";
import ApprovedTransfers from "@/components/landrate/ApprovedTransfers";

import PlotRent from "@/components/plotrent/PlotRent";
import PlotStatements from "@/components/plotrent/PlotStatements.vue";




import HousingRegister from "@/components/housing/HousingRegister.vue";
import HousingNew from "@/components/housing/HousingNew.vue";
import HousingNewUnit from "@/components/housing/HousingNewUnit.vue";
import ExpiredFireCert from "@/components/fire/ExpiredFireCert.vue";
import HousingDetail from "@/components/housing/HousingDetail.vue";
import FirePaidBills from "@/components/fire/FirePaidBills.vue";
import CertAlcoholOngoing from "@/components/liquor/CertAlcoholOngoing.vue";
import CertAlcoholPendingInspection from "@/components/liquor/CertAlcoholPendingInspection.vue";
import CertAlcoholPendingReview from "@/components/liquor/CertAlcoholPendingReview.vue";
import CertAlcoholApproved from "@/components/liquor/CertAlcoholApproved.vue";
import CertAlcoholActive from "@/components/liquor/CertAlcoholActive.vue";
import CertAlcoholActiveCert from "@/components/liquor/CertAlcoholActivePending.vue";
import LiquorPermit from "../../public/PrintDocs/Alcohol/LiquorPermit.vue";
import CertAlcoholDashboard from "@/components/liquor/CertAlcoholDashboard.vue";
import HygieneDashboard from "@/components/hygiene/HygieneDashboard.vue";
import CertHygienePending from "@/components/hygiene/CertHygienePending.vue";
import PendingApprovalHygiene from "@/components/hygiene/PendingApprovalHygiene.vue";
import ActiveHygieneCert from "@/components/hygiene/ActiveHygieneCert.vue";
import ExpiredHygieneCert from "@/components/hygiene/ExpiredHygieneCert.vue";
import HygienePaidBills from "@/components/hygiene/HygienePaidBills.vue";
import HealthPermit from "../../public/PrintDocs/hygene/HealthPermit.vue";
import MedicalDashboard from "@/components/medical/MedicalDashboard.vue";
import CertMedicalPending from "@/components/medical/CertMedicalPending.vue";
import PendingApprovalMedical from "@/components/medical/PendingApprovalMedical.vue";
import ActiveMedicalCert from "@/components/medical/ActiveMedicalCert.vue";
import ExpiredMedicalCert from "@/components/medical/ExpiredMedicalCert.vue";
import MedicalPaidBills from "@/components/medical/MedicalPaidBills.vue";
import MedicalCertificate from "../../public/PrintDocs/healthCertificates/MedicalCertificate.vue";
import ReportsSources from "@/components/reports/sources/ReportsSources.vue";
import WaivedBills from "@/components/invoices/WaivedBills.vue";
import ReportsStreamsUnpaid from "@/components/reports/unpaid/ReportsStreamsUnpaid.vue";
import UnPaidBillsStreams from "@/components/reports/unpaid/UnPaidBillsStreams.vue";

import ReportsStreamsPaid from "@/components/reports/paid/ReportsStreamsPaid.vue";
import PaidBillsStreams from "@/components/reports/paid/PaidBillsStreams.vue";
import ChangePassword from "../../public/PrintDocs/Authentication/ChangePassword.vue";
import ChangePassword2 from "../../public/PrintDocs/Authentication/ChangePassword2.vue";
import BusinessRegister from "@/components/sbp/BusinessRegister2.vue";
import PreviousRegister from "@/components/sbp/bulk/PreviousRegister.vue";
import Archived from "@/components/sbp/bulk/Archived.vue";
import PendingRecords from "@/components/sbp/bulk/PendingRecords";
import PendingDowngrade from "@/components/sbp/bulk/PendingDowngrade.vue";
import RejectedDowngrade from "@/components/sbp/bulk/RejectedDowngrade.vue";
import ApprovedDowngrade from "@/components/sbp/bulk/ApprovedDowngrade.vue";
import NewRegister from "@/components/sbp/bulk/NewRegister.vue";
import StatsBulk from "@/components/sbp/bulk/StatsBulk.vue";
import BulkInvoicer from "@/components/sbp/bulk/BulkInvoicer.vue";
import TransactionsCodesSearch from "@/components/TransactionsCodesSearch.vue";
import EwalletSystem from "@/components/wallet/EwalletSystem.vue";
import ParkSystem from "@/components/park/ParkSystem.vue";
import BulkBillUpload from "@/components/invoices/BulkBillUpload.vue";
import DisputeResolution from "@/components/disputes/DisputeResolution.vue";
import SystemIntegrationDashboard from "@/components/integrations/SystemIntegrationDashboard.vue";
import SecurityDashboard from "@/components/security/SecurityDashboard.vue";
import PaymentConfiguration from "@/components/payments/PaymentConfiguration.vue";

/*Waiver*/
import WaiverPending from "@/components/waiver/WaiverPending.vue";
import WaiverApproved from "@/components/waiver/WaiverApproved.vue";
import WaiverDeclined from "@/components/waiver/WaiverDeclined.vue";
import WaiverReverted from "@/components/waiver/WaiverReverted.vue";

/*Pwd*/
import PwdPending from "@/components/pwd/PwdPending.vue";
import PwdApproved from "@/components/pwd/PwdApproved.vue";
import PwdDeclined from "@/components/pwd/PwdDeclined.vue";
import PwdReverted from "@/components/pwd/PwdReverted.vue";

/*e-construction*/
import eConstructionProgress from "@/components/econstruct/eConstructionProgress.vue";
import eConstructionApplication from "@/components/econstruct/eConstructionApplication.vue";
import eConstructionApproved from "@/components/econstruct/eConstructionApproved.vue";
import eConstructionNewProfessional from "@/components/econstruct/eConstructionNewProfessional.vue";
import eConstructionProfessional from "@/components/econstruct/eConstructionProfessional.vue";
import eConstructionRejected from "@/components/econstruct/eConstructionRejected.vue";
import eConstructionRejectedProfessional from "@/components/econstruct/eConstructionRejectedProfessional.vue";
import eConstructionStats from "@/components/econstruct/eConstructionStats.vue";

/*landrate Transfre*/
import TransferCertificate from "../../public/PrintDocs/Alcohol/TransferCertificate.vue";
import {biller, execute} from "@/api";
import BillsRaisedWithNoCollectors from "@/components/invoices/BillsRaisedWithNoCollectors.vue";
import CertAlcoholApprovedPending from "@/components/liquor/CertAlcoholApprovedPending.vue";
import CustomerManagement from "@/components/profle/CustomerManagement.vue";

import InternetMapping from "@/components/internet/InternetMapping.vue";

import ValuationDashboard from '@/components/valuation/ValuationDashboard.vue'
import ValuationProperties from '@/components/valuation/ValuationProperties.vue'
import ValuationRequests from '@/components/valuation/ValuationRequests.vue'
import ValuationWalkIn from '@/components/valuation/ValuationWalkIn.vue'
import ValuationApprovals from '@/components/valuation/ValuationApprovals.vue'

import MarketsDashboard from '@/components/markets/MarketsDashboard.vue'
import MarketsAnalytics from '@/components/markets/MarketsAnalytics.vue'

import LandGIS from '@/components/landrate/LandGIS.vue'
import TaxpayerDatabase from '@/components/taxpayers/TaxpayerDatabase.vue'
import CountyPropertyManagement from '@/components/properties/CountyPropertyManagement.vue'
import TradePermitUBP from "../../public/PrintDocs/Trade-Permit/TradePermitUBP.vue";
import OutdoorAdvert from "@/components/adverts/OutdoorAdvert.vue";
import CleanupPage from "@/components/invoices/CleanupPage.vue";
import DuplicateInvoiceManagement from "@/components/invoices/DuplicateInvoiceManagement.vue";
import BusinessPermitsPerformanceDashboard from "@/components/sbp/BusinessPermitsPerformanceDashboard.vue";
import AIAssistant from "@/components/ai/AIAssistant.vue";
import CollectorPerformanceRankings from "@/components/rankings/CollectorPerformanceRankings.vue";
import DuplicateBillNoManagement from "@/components/invoices/DuplicateBillNoManagement.vue";
import ReportsStreamsDetails from "@/components/reports/streams/ReportsStreamsDetails.vue";
import ReportsStreamsDetailsTransactions from "@/components/reports/streams/ReportsStreamsDetailsTransactions.vue";
import Businesstypeanalytics from "@/components/sbp/Businesstypeanalytics.vue";
import BillApprovals from "@/components/econstruct/BillApprovals.vue";
import ApprovedBills from "@/components/econstruct/ApprovedBills.vue";
import DepartmentPerformance from "@/components/reports/department/DepartmentPerformance.vue";
import DepartmentPerformanceDetails from "@/components/reports/department/DepartmentPerformanceDetails.vue";
import ClearanceDashboard from "@/components/landrate/ClearanceDashboard.vue";

import ClearanceCertificatePrint from "../../public/PrintDocs/LandPermits/ClearanceCertificatePrint.vue";
import PendingClearanceCertificates from "@/components/landrate/PendingClearanceCertificates.vue";
import ApprovedClearanceCertificates from "@/components/landrate/ApprovedClearanceCertificates.vue";
import DeclinedClearanceCertificates from "@/components/landrate/DeclinedClearanceCertificates.vue";
import ClearanceCertificates from "@/components/landrate/ClearanceCertificates.vue";
import Propertystatement from "@/components/landrate/Propertystatement.vue";



const routes =[

    {
        path: '/ranking',
        name: 'ranking',
        component: CollectorPerformanceRankings,
        meta:{public: true}
    },

    {
        path: '/sbp-performance-dashboard',
        name: 'sbp-performance-dashboard',
        component: BusinessPermitsPerformanceDashboard,
        meta:{public: true}
    },

    {
        path: '/business-type-analytics',
        name: 'business-type-analytics',
        component: Businesstypeanalytics,
        meta:{public: true}
    },

    {
        path: '/ai-assistant',
        name: 'ai-assistant',
        component: AIAssistant,
        meta:{public: true}
    },

    {
        path: '/duplicate-invoice-management',
        name: 'duplicate-invoice-management',
        component: DuplicateInvoiceManagement,
        meta:{public: true}
    },

    {
        path: '/duplicate-bill-no-management',
        name: 'duplicate-bill-no-management',
        component: DuplicateBillNoManagement,
        meta:{public: true}
    },

    {
        path: '/orphanes',
        name: 'orphanes',
        component: CleanupPage,
        meta:{public: true}
    },

    {
        path: '/property-management',
        name: 'property-management',
        component: CountyPropertyManagement,
        meta:{public: true}
    },
    {
        path: '/taxpayer-database',
        name: 'taxpayer-database',
        component: TaxpayerDatabase,
        meta:{public: true}
    },
    {
        path: '/payment-configurations',
        name: 'payment-configurations',
        component: PaymentConfiguration,
        meta:{public: true}
    },
    {
        path: '/security-dashboard',
        name: 'security-dashboard',
        component: SecurityDashboard,
        meta:{public: true}
    },
    {
        path: '/cert-alcohol-approve-cert',
        name: 'cert-alcohol-approve-cert',
        component: CertAlcoholActiveCert,
        meta:{public: true}
    },
    {
        path: '/system-integrations',
        name: 'system-integrations',
        component: SystemIntegrationDashboard,
        meta:{public: true}
    },
    {
        path: '/dispute-resolution',
        name: 'dispute-resolution',
        component: DisputeResolution,
        meta:{public: true}
    },
    {
        path: '/bulk-bill-upload',
        name: 'bulk-bill-upload',
        component: BulkBillUpload,
        meta:{public: true}
    },
    {
        path: '/park-system',
        name: 'park-system',
        component: ParkSystem,
        meta:{public: true}
    },
    {
        path: '/e-wallet-system',
        name: 'e-wallet-system',
        component: EwalletSystem,
        meta:{public: true}
    },

    {
        path: '/land-gis',
        name: 'land-gis',
        component: LandGIS,
        meta:{public: true}
    },

    {
        path: '/markets_analytics',
        name: 'markets_analytics',
        component: MarketsAnalytics,
        meta:{public: true}
    },
    {
        path: '/markets_dashboard',
        name: 'markets_dashboard',
        component: MarketsDashboard,
        meta:{public: true}
    },

    {
        path: '/outdoor-advertising',
        name: 'outdoor-advertising',
        component: OutdoorAdvert,
        meta:{public: true}
    },
    {
        path: '/valuation-dashboard',
        name: 'valuation-dashboard',
        component: ValuationDashboard,
        meta:{public: true}
    },
    {
        path: '/valuation-properties',
        name: 'valuation-properties',
        component: ValuationProperties,
        meta:{public: true}
    },
    {
        path: '/valuation-requests',
        name: 'valuation-requests',
        component: ValuationRequests,
        meta:{public: true}
    },
    {
        path: '/valuation-walk-in',
        name: 'valuation-walk-in',
        component: ValuationWalkIn,
        meta:{public: true}
    },
    {
        path: '/valuation-approvals',
        name: 'valuation-approvals',
        component: ValuationApprovals,
        meta:{public: true}
    },


    {
        path:"/internet-mapping",
        name:"internet-mapping",
        component: InternetMapping,
        meta:{public: true}
    },
    {
        path:"/transfer-certificate",
        name:"transfer-certificate",
        component: TransferCertificate,
        meta:{public: true}
    },

    {
        path:"/transactions-codes-search",
        name:"transactions-codes-search",
        component: TransactionsCodesSearch,
        meta:{public: true}
    },


    /*e-construction*/
    {
        path:"/e-construction-rejected-professional",
        name:"e-construction-rejected-professional",
        component: eConstructionRejectedProfessional,
        meta:{public: false}
    },

    {
        path:"/e-construction-rejected",
        name:"e-construction-rejected",
        component: eConstructionRejected,
        meta:{public: false}
    },

    {
        path:"/e-construction-progress",
        name:"e-construction-progress",
        component: eConstructionProgress,
        meta:{public: false}
    },
    {
        path:"/e-construction-approved",
        name:"e-construction-approved",
        component: eConstructionApproved,
        meta:{public: false}
    },
    {
        path:"/e-construction-new-professional",
        name:"e-construction-new-professional",
        component: eConstructionNewProfessional,
        meta:{public: false}
    },
    {
        path:"/e-construction-professional",
        name:"e-construction-professional",
        component: eConstructionProfessional,
        meta:{public: false}
    },
    {
        path:"/e-construction-stats",
        name:"e-construction-stats",
        component: eConstructionStats,
        meta:{public: false}
    },
    {
        path:"/e-construction-application",
        name:"e-construction-application",
        component: eConstructionApplication,
        meta:{public: false}
    },

    /*Pwd*/
    {
        path:"/pwd-pending",
        name:"pwd-pending",
        component: PwdPending,
        meta:{public: false}
    },

    {
        path:"/pwd-approved",
        name:"pwd-approved",
        component: PwdApproved,
        meta:{public: false}
    },
    {
        path:"/pwd-declined",
        name:"pwd-declined",
        component: PwdDeclined,
        meta:{public: false}
    },
    {
        path:"/pwd-reverted",
        name:"pwd-reverted",
        component: PwdReverted,
        meta:{public: false}
    },

    /*waver*/
    {
        path:"/waiver-pending",
        name:"waiver-pending",
        component: WaiverPending,
        meta:{public: false}
    },

    {
        path:"/waiver-approved",
        name:"waiver-approved",
        component: WaiverApproved,
        meta:{public: false}
    },
    {
        path:"/waiver-declined",
        name:"waiver-declined",
        component: WaiverDeclined,
        meta:{public: false}
    },
    {
        path:"/waiver-reverted",
        name:"waiver-reverted",
        component: WaiverReverted,
        meta:{public: false}
    },

    {
        path:"/otp-verification",
        name:"otp2",
        component: otp2,
        meta:{public: true}
    },


    {
        path:"/otp",
        name:"otp",
        component: otp2,
        meta:{public: true}
    },

    {
        path:"/",
        name:"login",
        component: Login2
        ,
        meta:{public: true}
    },

    {
        path:"/bulk-invoicer",
        name:"bulk-invoicer",
        component: BulkInvoicer,
        meta:{public: false}
    },
    {
        path:"/bulk-receipts",
        name:"bulk-receipts",
        component: BulkReceipts,
        meta:{public: true}
    },

    {
        path:"/stats-bulk",
        name:"stats-bulk",
        component: StatsBulk,
        meta:{public: false}
    },
    {
        path:"/new-register",
        name:"new-register",
        component: NewRegister,
        meta:{public: false}
    },
    {
        path:"/approved-downgrade",
        name:"approved-downgrade",
        component: ApprovedDowngrade,
        meta:{public: false}
    },
    {
        path:"/rejected-downgrade",
        name:"rejected-downgrade",
        component: RejectedDowngrade,
        meta:{public: false}
    }, {
        path:"/pending-downgrade",
        name:"pending-downgrade",
        component: PendingDowngrade,
        meta:{public: false}
    },
    {
        path:"/pending-records",
        name:"pending-records",
        component: PendingRecords,
        meta:{public: false}
    },
    {
        path:"/archived",
        name:"archived",
        component: Archived,
        meta:{public: false}
    },
    {
        path:"/previous-register",
        name:"previous-register",
        component: PreviousRegister,
        meta:{public: false}
    },
    {
        path:"/business-register",
        name:"business-register",
        component: BusinessRegister,
        meta:{public: false}
    },
    {
        path:"/change-password",
        name:"change-password",
        component: ChangePassword,
        meta:{public: false}
    },

    {
        path:"/change-password-verification",
        name:"change-password-verification",
        component: ChangePassword2,
        meta:{public: true}
    },


    {
        path:"/paid-bills-streams",
        name:"paid-bills-streams",
        component: PaidBillsStreams,
        meta:{public: false}
    },

    {
        path:"/reports-streams-paid",
        name:"reports-streams-paid",
        component: ReportsStreamsPaid,
        meta:{public: false}
    },

    {
        path:"/un-paid-bills-streams",
        name:"un-paid-bills-streams",
        component: UnPaidBillsStreams,
        meta:{public: false}
    },

    {
        path:"/reports-streams-unpaid",
        name:"reports-streams-unpaid",
        component: ReportsStreamsUnpaid,
        meta:{public: false}
    },
    {
        path:"/waived-bills",
        name:"waived-bills",
        component: WaivedBills,
        meta:{public: false}
    },
    {
        path:"/reports-sources",
        name:"reports-sources",
        component: ReportsSources,
        meta:{public: false}
    },
    {
        path:"/medical-certificate",
        name:"medical-certificate",
        component: MedicalCertificate,
        meta:{public: false}
    },
    {
        path:"/medical-paid-bills",
        name:"medical-paid-bills",
        component: MedicalPaidBills,
        meta:{public: false}
    },
    {
        path:"/expired-medical-cert",
        name:"expired-medical-cert",
        component: ExpiredMedicalCert,
        meta:{public: false}
    },
    {
        path:"/active-medical-cert",
        name:"active-medical-cert",
        component: ActiveMedicalCert,
        meta:{public: false}
    },
    {
        path:"/pending-approval-medical",
        name:"pending-approval-medical",
        component: PendingApprovalMedical,
        meta:{public: false}
    },
    {
        path:"/cert-medical-pending",
        name:"cert-medical-pending",
        component: CertMedicalPending,
        meta:{public: false}
    },
    {
        path:"/medical-dashboard",
        name:"medical-dashboard",
        component: MedicalDashboard,
        meta:{public: false}
    },
    {
        path:"/health-permit",
        name:"health-permit",
        component: HealthPermit,
        meta:{public: true}
    },
    {
        path:"/hygiene-paid-bills",
        name:"hygiene-paid-bills",
        component: HygienePaidBills,
        meta:{public: false}
    },
    {
        path:"/expired-hygieneCert",
        name:"expired-hygieneCert",
        component: ExpiredHygieneCert,
        meta:{public: false}
    },
    {
        path:"/active-hygieneCert",
        name:"active-hygieneCert",
        component: ActiveHygieneCert,
        meta:{public: false}
    },
    {
        path:"/pending-approval-hygiene",
        name:"pending-approval-hygiene",
        component: PendingApprovalHygiene,
        meta:{public: false}
    },
    {
        path:"/cert-hygiene-pending",
        name:"cert-hygiene-pending",
        component: CertHygienePending,
        meta:{public: false}
    },
    {
        path:"/hygiene-dashboard",
        name:"hygiene-dashboard",
        component: HygieneDashboard,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-dashboard",
        name:"cert-alcohol-dashboard",
        component: CertAlcoholDashboard,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-active",
        name:"cert-alcohol-active",
        component: CertAlcoholActive,
        meta:{public: false}
    },

    {
        path:"/liquor-permit",
        name:"liquor-permit",
        component: LiquorPermit,
        meta:{public: true}
    },
    {
        path:"/cert-alcohol-approved",
        name:"cert-alcohol-approved",
        component: CertAlcoholApproved,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-approved-pending",
        name:"cert-alcohol-approved-pending",
        component: CertAlcoholApprovedPending,
        meta:{public: false}
    },
    {
        path:"/customer-management",
        name:"customer-management",
        component: CustomerManagement,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-review",
        name:"cert-alcohol-review",
        component: CertAlcoholPendingReview,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-inspection",
        name:"cert-alcohol-inspection",
        component: CertAlcoholPendingInspection,
        meta:{public: false}
    },
    {
        path:"/cert-alcohol-ongoing",
        name:"cert-alcohol-ongoing",
        component: CertAlcoholOngoing,
        meta:{public: false}
    },
    {
        path:"/housing-detail",
        name:"housing-detail",
        component: HousingDetail,
        meta:{public: false}
    },
    {
        path:"/fire-paid-bills",
        name:"fire-paid-bills",
        component: FirePaidBills,
        meta:{public: false}
    },
    {
        path:"/expired-fireCert",
        name:"expired-fireCert",
        component: ExpiredFireCert,
        meta:{public: false}
    },
    {
        path:"/housing-new",
        name:"housing-new",
        component: HousingNew,
        meta:{public: false}
    },
    {
        path:"/housing-new-unit",
        name:"housing-new-unit",
        component: HousingNewUnit,
        meta:{public: false}
    },
    {
        path:"/housing-register",
        name:"housing-register",
        component: HousingRegister,
        meta:{public: false}
    },
    {
        path:"/plot-statements",
        name:"plot-statements",
        component: PlotStatements,
        meta:{public: false}
    },

    {
        path:"/property-statement",
        name:"property-statement",
        component: Propertystatement,
        meta:{public: false}
    },

    {
        path:"/land-rate",
        name:"land-rate",
        component: LandRate,
        meta:{public: false}
    },
    {
        path:"/pending-transfer",
        name:"pending-transfer",
        component: PendingTransfers,
        meta:{public: false}
    },


    {
        path:"/decline-transfer",
        name:"decline-transfer",
        component: DeclinedTransfers,
        meta:{public: false}
    },
    {
        path:"/re-approve-transfer",
        name:"re-approve-transfer",
        component: ReApproveTransfers,
        meta:{public: false}
    },
    {
        path:"/approved-transfer",
        name:"approved-transfer",
        component: ApprovedTransfers,
        meta:{public: false}
    },
    {
        path:"/demand-notice",
        name:"demand-notice",
        component: DemandNotice,
        meta:{public: true}
    },
    {
        path:"/construction-permits",
        name:"construction-permits",
        component: ConstructionPermits,
        meta:{public: true}
    },
    {
        path:"/fire-permit",
        name:"fire-permit",
        component: FirePermit,
        meta:{public: true}
    },
    {
        path:"/active-fireCert",
        name:"active-fireCert",
        component: ActiveFireCert,
        meta:{public: false}
    },
    {
        path:"/pending-approval-fire",
        name:"pending-approval-fire",
        component: PendingApprovalFire,
        meta:{public: false}
    },
    {
        path:"/cert-fire-pending",
        name:"cert-fire-pending",
        component: CertFirePending,
        meta:{public: false}
    },
    {
        path:"/fire-dashboard",
        name:"fire-dashboard",
        component: FireDashboard,
        meta:{public: false}
    },
    {
        path:"/plot_rent",
        name:"plot_rent",
        component: PlotRent,
        meta:{public: false}
    },

    {
        path:"/flagged-transaction-correction",
        name:"flagged-transaction-correction",
        component: FlaggedTransactionCorrection,
        meta:{public: false}
    },
    {
        path:"/transaction-correction-request",
        name:"transaction-correction-request",
        component: TransactionCorrectionRequest,
        meta:{public: false}
    },

    {
        path:"/recon",
        name:"recon",
        component: Recon,
        meta:{public: false}
    },
    {
        path:"/recon-details",
        name:"recon-details",
        component: ReconDetails,
        meta:{public: false}
    },

    {
        path:"/bank-reconciliation",
        name:"bank-reconciliation",
        component: ReconRealtime,
        meta:{public: false}
    },

    {
        path:"/recon-all",
        name:"recon-all",
        component: AllReconDetails,
        meta:{public: false}
    },
    {
        path:"/parking-fleet-details-history",
        name:"parking-fleet-details-history",
        component: ParkingFleetDetailsHistory,
        meta:{public: false}
    },
    {
        path:"/parking-fleet-details-statements",
        name:"parking-fleet-details-statements",
        component: ParkingFleetDetailsStatements,
        meta:{public: false}
    },
    {
        path:"/clamped_vehicles",
        name:"clamped_vehicles",
        component: ClampedVehicles,
        meta:{public: false}
    },
    {
        path:"/parking_dashboard",
        name:"parking_dashboard",
        component: ParkingDashboard,
        meta:{public: false}
    },{
        path:"/vehicles_register",
        name:"vehicles_register",
        component: VehicleRegister,
        meta:{public: false}
    },{
        path:"/bus_park",
        name:"bus_park",
        component: BusParkParking,
        meta:{public: false}
    },{
        path:"/monthly_parking",
        name:"monthly_parking",
        component: MonthlyParking,
        meta:{public: false}
    },
    {
        path:"/weekly_parking",
        name:"weekly_parking",
        component: WeeklyParking,
        meta:{public: false}
    },
    {
        path:"/daily_parking",
        name:"daily_parking",
        component: DailyParking,
        meta:{public: false}
    },
    {
        path:"/parking-fleet-details",
        name:"parking-fleet-details",
        component: ParkingFleetDetails,
        meta:{public: false}
    },
    {
        path:"/reports-streams",
        name:"reports-streams",
        component: ReportsStreams,
        meta:{public: false
        }
    },

    {
        path:"/reports-streams-details",
        name:"reports-streams-details",
        component: ReportsStreamsDetails,
        meta:{public: false
        }
    },
    {
        path:"/reports-streams-details-transactions",
        name:"reports-streams-details-transactions",
        component: ReportsStreamsDetailsTransactions,
        meta:{public: false
        }
    },
    {
        path:"/reports-sub-county-revenue-streams",
        name:"reports-sub-county-revenue-streams",
        component: ReportsSubCountyRevenueStreams,
        meta:{public: false
        }
    },
    {
        path:"/set-accounts",
        name:"set-accounts",
        component: SetAccounts,
        meta:{public: false
        }
    },
    {
        path:"/reports-streams-sub-counties",
        name:"reports-streams-sub-counties",
        component: ReportsStreamsSubcounties,
        meta:{public: false}
    },
    {
        path:"/reports-streams-wards",
        name:"reports-streams-wards",
        component: ReportsStreamsWards,
        meta:{public: false}
    },
    {
        path:"/reports-streams-zones",
        name:"reports-streams-zones",
        component: ReportsStreamsZones,
        meta:{public: false}
    },
    {
        path:"/reports-agents",
        name:"reports-agents",
        component: ReportsAgents,
        meta:{public: false
        }
    },
    {
        path:"/targets-SubCounty",
        name:"targets-SubCounty",
        component: TargetsSubCounty,
        meta:{public: false}
    },
    {
        path:"/parking-sticker",
        name:"parking-sticker",
        component: ParkingSticker,
        meta:{public: false}
    }
    ,
    {
        path:"/reports-agents-details",
        name:"reports-agents-details",
        component: ReportsAgentsDetails,
        meta:{public: false}
    },
    {
        path:"/dashboard",
        name:"dashboard",
        component: Dashboard,
        meta:{public: false}
    },
    {
        path:"/dashboard2",
        name:"dashboard2",
        component: Dashboard2,
        meta:{public: false}
    },
    {
        path:"/new-bill",
        name:"newBill",
        component: NewBill,
        meta:{public: false}
    },

    {
        path: '/bill',
        name: 'bill',
        component: Bill,
        meta:{public: false}
    },
    {
        path: "/receipt",
        name: "receipt",
        component: PrintReceipt,
        meta: {public: false}
    },
    {
        path: "/bills-raised",
        name: "bills-raised",
        component: BillsRaised,
        meta: {public: false}
    },
    {
        path: "/un-paid-bills",
        name: "un-paid-bills",
        component: UnPaidBills,
        meta: {public: false}
    },

    {
        path: "/invoices-no-collectors",
        name: "invoices-no-collectors",
        component: BillsRaisedWithNoCollectors,
        meta: {public: false}
    },
    {
        path: "/bills-receipted",
        name: "bills-receipted",
        component: BillsReceipted,
        meta: {public: false}
    },
    {
        path: "/receipts",
        name: "receipts",
        component: ReceiptedPayments,
        meta: {public: false}
    },
    {
        path: "/receipts-new",
        name: "receipts-new",
        component: ReceiptsNew,
        meta: {public: false}
    },
    {
        path: "/permits",
        name: "permits",
        component: TradePermts,
        meta: {public: false}
    },{
        path: "/trade",
        name: "trade",
        component: TradePermit,
        meta: {public: true}
    },
    {
        path: "/trade-ubp",
        name: "trade-ubp",
        component: TradePermitUBP,
        meta: {public: true}
    },
    {
        path: "/trade-plain",
        name: "trade-plain",
        component: TradePermitWithNoLogo,
        meta: {public: true}
    },
    {
        path: "/customers",
        name: "customers",
        component: Customers,
        meta: {public: false}
    },
    {
        path: "/add-users",
        name: "add-users",
        component: AddUser,
        meta: {public: false}
    },
    {
        path: "/users",
        name: "users",
        component: Users,
        meta: {public: false}
    },{
        path: "/transactions",
        name: "transactions",
        component: Transactions,
        meta: {public: false}
    },{
        path: "/zones",
        name: "zones",
        component: Zones,
        meta: {public: false}
    },
    {
        path: "/finance-act",
        name: "finance-act",
        component: FinanceAct,
        meta: {public: false}
    },
    {
        path: "/department",
        name: "department",
        component: Department,
        meta: {public: false}
    }, {
        path: "/revenue-stream",
        name: "revenue-stream",
        component: RevenueStream,
        meta: {public: false}
    },{
        path: "/sub-county-report",
        name: "sub-county-report",
        component: SubCountyReport,
        meta: {public: false}
    },
    {
        path: "/sbp-bulk-invoice-report",
        name: "sbp-bulk-invoice-report",
        component: SBPBulkInvoiceReport,
        meta: {public: false}
    },
    {
        path: "/rentals",
        name: "rentals",
        component: Rentals,
        meta: {public: false}
    },
    {
        path: "/stalls",
        name: "stalls",
        component: Stalls,
        meta: {public: false}
    },{
        path: "/agent-transactions",
        name: "agent-transactions",
        component: AgentsTransactions,
        meta: {public: false}
    },
    {
        path: "/user-logs",
        name: "user-logs",
        component: UserLogs,
        meta: {public: false}
    },
    {
        path: "/all-user-logs",
        name: "all-user-logs",
        component: AllUserLogs,
        meta: {public: false}
    },

    {
        path: "/user-collections",
        name: "user-collections",
        component: UserCollections,
        meta: {public: false}
    },{
        path: "/reports-sub-county",
        name: "reports-sub-county",
        component: ReportsSubCounty,
        meta: {public: false}
    },
    {
        path: "/reports-sub-counties-details",
        name: "reports-sub-counties-details",
        component: ReportsSubCountyDetails,
        meta: {public: false}
    },{
        path: "/reports-sub-county-streams",
        name: "reports-sub-county-streams",
        component: ReportsSubCountyStreams,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-streams-break-down",
        name: "reports-sub-county-streams-break-down",
        component: ReportsSubCountyStreamsBreakdown,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-streams-details",
        name: "reports-sub-county-streams-details",
        component: ReportsSubCountyStreamsDetails,
        meta: {public: false}
    },

    {
        path: "/live_monitoring",
        name: "live_monitoring",
        component: LiveMonitoring,
        meta: {public: false}
    },
    {
        path: "/active_users",
        name: "active_users",
        component: ActiveUsers,
        meta: {public: false}
    },
    {
        path: "/offline_users",
        name: "offline_users",
        component: InActiveUsers,
        meta: {public: false}
    },
    {
        path: "/dormant_users",
        name: "dormant_users",
        component: DormantUsers,
        meta: {public: false}
    },
    {
        path: "/never_logged_in",
        name: "never_logged_in",
        component: NeverLoggedIn,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-zones",
        name: "reports-sub-county-zones",
        component: ReportsSubCountyZones,
        meta: {public: false}
    },{
        path: "/reports-sub-county-zones-details",
        name: "reports-sub-county-zones-details",
        component: ReportsSubCountyZonesDetails,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-agents",
        name: "reports-sub-county-agents",
        component: ReportsSubCountyAgents,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-agent-details",
        name: "reports-sub-county-agent-details",
        component: ReportsSubCountyAgentDetails,
        meta: {public: false}
    },
    {
        path: "/mapping",
        name: "mapping",
        component: Mapping,
        meta: {public: false}
    },
    {
        path: "/cert-biz-stats",
        name: "cert-biz-stats",
        component: CertBizStats,
        meta: {public: false}
    },
    {
        path: "/pending-validation",
        name: "pending-validation",
        component: PendingValidation,
        meta: {public: false}
    },
    {
        path: "/pending-inspection",
        name: "pending-inspection",
        component: PendingInspection,
        meta: {public: false}
    },
    {
        path: "/pending-approval",
        name: "pending-approval",
        component: PendingApproval,
        meta: {public: false}
    },{
        path: "/declined",
        name: "declined",
        component: Declined,
        meta: {public: false}
    },{
        path: "/approved",
        name: "approved",
        component: Approved,
        meta: {public: false}
    },
    {
        path: "/expired",
        name: "expired",
        component: Expired,
        meta: {public: false}
    },{
        path: "/paid-sbp",
        name: "paid-sbp",
        component: PaidSBP,
        meta: {public: false}
    },{
        path: "/unpaid-sbp",
        name: "unpaid-sbp",
        component: UnPaidSBP,
        meta: {public: false}
    },{
        path: "/sbp-unpaid-bills",
        name: "sbp-unpaid-bills",
        component: SbpUnPaidBills,
        meta: {public: false}
    },{
        path: "/sbp-paid-bills",
        name: "sbp-paid-bills",
        component: SbpPaidBills,
        meta: {public: false}
    },{
        path: "/sbp-map",
        name: "sbp-map",
        component: SBPMap,
        meta: {public: false}
    },
    {
        path: "/sbp-map-filter",
        name: "sbp-map-filter",
        component: SBPFilterMap,
        meta: {public: false}
    },
    {
        path: "/targets-collectors",
        name: "targets-collectors",
        component: TargetsCollectors,
        meta: {public: false}

    }, {
        path: "/targets-stream",
        name: "targets-stream",
        component: TargetStream,
        meta: {public: false}
    },
    {
        path: "/targets-zones",
        name: "targets-zones",
        component: TargetsZones,
        meta: {public: false}
    },
    {
        path: "/targets-wards",
        name: "targets-wards",
        component: TargetsWards,
        meta: {public: false}
    },
    {
        path: "/reports-sub-county-team",
        name: "reports-sub-county-team",
        component: ReportsSubCountyTeam,
        meta: {public: false}
    }, {
        path: "/reports-sub-county-team-details",
        name: "reports-sub-county-team-details",
        component: ReportsSubCountyTeamDetails,
        meta: {public: false}
    },
    {
        path: "/business-data",
        name: "business-data",
        component: BusinessData,
        meta: {public: false}
    },{
        path: "/business-mapping",
        name: "business-mapping",
        component: BusinessMapping,
        meta: {public: false}
    },{
        path: "/parking-fleet",
        name: "parking-fleet",
        component: ParkingFleet,
        meta: {public: false}
    },
    {
        path: "/parking-fleet-new",
        name: "parking-fleet-new",
        component: ParkingFleetNewSacco,
        meta: {public: false}
    }, {
        path: "/parking-fleet-payment",
        name: "parking-fleet-payment",
        component: ParkingFleetPayment,
        meta: {public: false}
    },

    {
        path: "/bill-approvals",
        name: "bill-approvals",
        component: BillApprovals,
        meta: {public: false}
    } ,
    {
        path: "/approved-bills",
        name: "approved-bills",
        component: ApprovedBills,
        meta: {public: false}
    },
    {
        path: "/department-performance",
        name: "/department-performance",
        component: DepartmentPerformance,
        meta: {public: false}
    }, {
        path: "/department-performance-details",
        name: "department-performance-details",
        component: DepartmentPerformanceDetails,
        meta: {public: false}
    },

    {
        path: '/clearance-dashboard',
        name: 'clearance-dashboard',
        component: ClearanceDashboard,
        meta: { public: true }
    },
    {
        path: '/clearance-certificates',
        name: 'clearance-certificates',
        component: ClearanceCertificates,
        meta: { public: true }
    },
    {
        path: '/clearance-pending',
        name: 'clearance-pending',
        component: PendingClearanceCertificates,
        meta: { public: true }
    },
    {
        path: '/clearance-approved',
        name: 'clearance-approved',
        component: ApprovedClearanceCertificates,
        meta: { public: true }
    },
    {
        path: '/clearance-declined',
        name: 'clearance-declined',
        component: DeclinedClearanceCertificates,
        meta: { public: true }
    },
    {
        path: '/clearance-certificate-print',
        name: 'clearance-certificate-print',
        component: ClearanceCertificatePrint,
        meta: { public: true }
    }
]
const router = createRouter({
    history: createWebHashHistory(),
    routes
});

let userActivityTimer;

router.beforeEach((to, from, next) => {
    // Reset the user activity timer on each navigation
    clearTimeout(userActivityTimer);

    // Check if the target route requires authentication
    if (!to.meta.public && !to.hash.includes('/trade/')) {
        // Check if the user is logged in or not
        if (sessionStorage.getItem("isLoggedIn")) {
            // If yes, allow the navigation
            next();

            // Set up the user activity timer
            userActivityTimer = setTimeout(() => {
                // Log out the user after 24 hours of inactivity
                sessionStorage.removeItem("isLoggedIn");
                next("/");
            }, 24 * 60 * 60 * 1000); // 24 hours in milliseconds
        } else {
            // If no, redirect the user to the login page
            next("/");
        }
    } else {
        // If the target route does not require authentication or has parameters, allow the navigation
        next();
    }
});

// Optionally, you may want to handle user activity within the application
// to reset the timer. Here's an example assuming you have a user activity event.

// Example: Reset timer on user activity
function handleUserActivity() {
    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        // Log out the user after 5 minutes of inactivity

        const data = new FormData();
        data.append("function", "timeout");
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
        execute(data,biller)
            .then(() => {

                sessionStorage.removeItem("isLoggedIn");
                router.push("/");

            })
            .catch(() => {
                // alert(e.message);
            });



    }, 24 * 60 * 60 * 1000); // 24 hours in milliseconds
}

// Attach an event listener for user activity (e.g., mousemove, keypress, etc.)
document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

// Remember to remove event listeners when they are no longer needed (e.g., when user logs out)
// document.removeEventListener("mousemove", handleUserActivity);
// document.removeEventListener("keypress", handleUserActivity);

export default router;